module.exports = __webpack_public_path__ + "static/img/mobile-bg.d7b74aac.png";